// extracted by mini-css-extract-plugin
module.exports = {"WrapPage":"ServiceLocation-list-screen_WrapPage__1l1ox"};